import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/FileCode.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: i }));
o.displayName = "FileCodeIcon";
const s = o;
export {
  s as FileCode,
  o as FileCodeIcon
};
